import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCampaign = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 20,
	viewBox: "0 0 24 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2 8.39999C19.2 9.20399 19.2 9.99599 19.2 10.8C20.64 10.8 22.512 10.8 24 10.8C24 9.99599 24 9.20399 24 8.39999C22.512 8.39999 20.64 8.39999 19.2 8.39999Z",
			fill: "#27AE60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8 16.332C17.952 17.184 19.452 18.312 20.64 19.2C21.12 18.564 21.6 17.916 22.08 17.28C20.892 16.392 19.392 15.264 18.24 14.4C17.76 15.048 17.28 15.696 16.8 16.332Z",
			fill: "#27AE60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.08 1.92C21.6 1.284 21.12 0.636 20.64 0C19.452 0.888 17.952 2.016 16.8 2.88C17.28 3.516 17.76 4.164 18.24 4.8C19.392 3.936 20.892 2.82 22.08 1.92Z",
			fill: "#27AE60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.4 5.99999C1.08 5.99999 0 7.07999 0 8.39999V10.8C0 12.12 1.08 13.2 2.4 13.2H3.6V18H6V13.2H7.2L13.2 16.8V2.39999L7.2 5.99999H2.4ZM8.436 8.05199L10.8 6.63599V12.564L8.436 11.148L7.86 10.8H7.2H2.4V8.39999H7.2H7.86L8.436 8.05199Z",
			fill: "#27AE60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2 9.59999C16.2 8.00399 15.504 6.56399 14.4 5.57999V13.608C15.504 12.636 16.2 11.196 16.2 9.59999Z",
			fill: "#27AE60"
		})
	]
});
export default SvgCampaign;
